var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelectAssuranceInput',{attrs:{"justify-end":_vm.justifyEnd,"assurance-level":_vm.assuranceLevel,"init-form":_vm.initForm},on:{"onSubmit":_vm.handleSubmit,"clearContent":_vm.clearContent}})}
var staticRenderFns = []

export { render, staticRenderFns }